define(function (require) {
    var $ = require("jquery");
    var _ = require("underscore");
    var apiUrl = window.scan && window.scan.apiUrl ? window.scan.apiUrl : "";
    var tierMapper;
    var coverageMapper;

    var mapBrowseLetters = function (results) {
        // iterate through the results to make sure letters/number not
        // returned in facet search (because there are no hits for it in the
        // search index) are still accounted for as zero count in the browse letters
        // area
        var browsing = "0abcdefghijklmnopqrstuvwxyz";
        var rv = [];

        if (results != null && $.isArray(results) && results.length > 0) {
            _.each(browsing, function (char) {
                var item = _.find(results, function (item) {
                    return item.Name.toLowerCase() == char;
                });

                rv.push(item == null ? { Name: char, Value: char, Count: 0, NameWithCount: char + " (0)" } : item);
            });
        }

        return rv;
    };

    var mapOptionsAndGroups = function (result, mapper) {
        if (mapper) {
            return _.map(result, function (item) {
                return {
                    count: item.Count || 0,
                    text: item.Name,
                    textWithCount: item.NameWithCount,
                    value: item.Value,
                    isSubCategory: item.IsSubCategory,
                    categoryName: item.CategoryName,
                    textTranslated: mapper[item.Name] ? mapper[item.Name] : ""
                };
            });
        } else {
            return _.map(result, function (item) {
                return {
                    count: item.Count || 0,
                    text: item.Name,
                    textWithCount: item.NameWithCount,
                    value: item.Value,
                    isSubCategory: item.IsSubCategory,
                    categoryName: item.CategoryName
                };
            });
        }
    };

    return {
        /**
         * Returns a jQuery promise for the formulary browse results.
         *
         * @param {} parameters Object of search parameters.
         * @returns {} Object with CurrentResults array, TotalResults integer, Facets array.
         */
        getBrowse: function (parameters) {
            parameters.withBrowseFacets = false;

            return $.getJSON(apiUrl + "/api/formularysearch/browse", parameters).then(function (results) {
                tierMapper = window.scan.formularyDosageTierMap;
                coverageMapper = window.scan.formularyDosageCoverageLimitMap;

                results.Facets = {
                    Categories: mapOptionsAndGroups(results.Facets.FormularyCategories),
                    CoverageLimits: mapOptionsAndGroups(results.Facets.CoverageLimits, coverageMapper),
                    TierNumber: mapOptionsAndGroups(results.Facets.TierNumber, tierMapper)
                };
                return results;
            });
        },
        /**
         * Returns a jQuery promise for the formulary search results.
         *
         * @param {} parameters Object of search parameters.
         * @returns {} Object with CurrentResults array, TotalResults integer, Facets array.
         */
        getResults: function (parameters, withBrowseFacets) {
            parameters.withBrowseFacets = withBrowseFacets ? true : false;

            return $.getJSON(apiUrl + "/api/formularysearch/results", parameters).then(function (results) {
                tierMapper = window.scan.formularyDosageTierMap;
                coverageMapper = window.scan.formularyDosageCoverageLimitMap;

                results.Facets = {
                    Categories: mapOptionsAndGroups(results.Facets.FormularyCategories),
                    CoverageLimits: mapOptionsAndGroups(results.Facets.CoverageLimits, coverageMapper),
                    TierNumber: mapOptionsAndGroups(results.Facets.TierNumber, tierMapper),
                    BrowseLetters: mapBrowseLetters(results.Facets.BrowseLetters)
                };

                return results;
            });
        },
        /**
         * Returns a jQuery promise for the drugs in the formulary index.  Includes non-formulary and forumulary
         *
         * @param {} parameters Object of search parameters.
         * @returns {} Object with CurrentResults array and TotalResults integer.
         */
        search: function (parameters) {
            return $.getJSON(apiUrl + "/api/formularysearch/search", parameters).then(function (results) {
                tierMapper = window.scan.formularyDosageTierMap;
                coverageMapper = window.scan.formularyDosageCoverageLimitMap;

                results.Facets = {
                    Categories: mapOptionsAndGroups(results.Facets.FormularyCategories),
                    CoverageLimits: mapOptionsAndGroups(results.Facets.CoverageLimits, coverageMapper),
                    TierNumber: mapOptionsAndGroups(results.Facets.TierNumber, tierMapper)
                };

                return results;
            });
        },
        /**
         * Returns a jQuery promise for the formulary suggestion results.
         *
         * @param {} parameters Object of search parameters.
         * @returns {} Object with CurrentResults array and TotalResults integer.
         */
        getSuggestions: function (parameters) {
            parameters.withBrowseFacets = false;

            return $.getJSON(apiUrl + "/api/formularysearch/suggestions", parameters).then(function (results) {
                tierMapper = window.scan.formularyDosageTierMap;
                coverageMapper = window.scan.formularyDosageCoverageLimitMap;

                results.Facets = {
                    Categories: mapOptionsAndGroups(results.Facets.FormularyCategories),
                    CoverageLimits: mapOptionsAndGroups(results.Facets.CoverageLimits, coverageMapper),
                    TierNumber: mapOptionsAndGroups(results.Facets.TierNumber, tierMapper)
                };
                return results;
            });
        }
    };
});
